<div *ngIf="updateData && !finalShiftReportData" class="modal-cierre">
  <h2 mat-dialog-title *ngIf="!isLoadingPdf">
    {{
      updateData.updateType.code === 'cierre_turno'
        ? 'Novedades Diarias Jefe de Turno'
        : updateData.updateType.code === 'cierre_turno_informe_diario'
          ? 'Informe Jefe de Turno'
          : updateData.updateType.name
    }}
  </h2>  

  <h2 mat-dialog-title *ngIf="isLoadingPdf">
    Previsualización
  </h2> 
  
  <div class="close-container">
    <button class="close" (click)="close()">
      <i class="fa-solid fa-xmark" alt=""></i>
    </button>
  </div>

  <div *ngIf="isLoadingPdf" class="pdf-loading-spinner">
    <mat-progress-spinner mode="indeterminate" [diameter]="25"></mat-progress-spinner>
    <p>  Generando previsualización del PDF...</p>
  </div>

  <!-- Mostrar mensaje de error si falla la previsualización -->
  <div *ngIf="errorMessage && !isLoadingPdf" class="py-4 px-4">
    <div class="alert alert-danger">{{ errorMessage }}</div>
  </div>

  <div *ngIf="!isPreviewMode">
    <form *ngIf="formGroup" [formGroup]="formGroup" >
    <div *ngIf="updateData">
      <mat-dialog-content>
        <!-- Si hay steps, mostrar stepper -->
        <mat-stepper
          *ngIf="groupedData.steps.length > 0"
          #stepper
          orientation="horizontal"
          (selectionChange)="onStepChange($event)"
        >
          <!-- Steps dinámicos -->
          <mat-step *ngFor="let stepData of groupedData.steps; let i = index" [label]="getStepLabel(stepData.step)">
            <!-- Indicador de paso actual -->
            
            <!-- Elementos agrupados dentro del step -->
            <div *ngFor="let group of stepData.grouped" class="grupo-inputs">
              <div *ngFor="let element of group.elements" [ngClass]="element.element.name === 'Label' ? 'subtitle col-span-4' : 'field'">
                <!-- Elementos individuales dentro del grupo -->
                <div *ngIf="element.element.name === 'TextBox'">
                  <label>{{ element.label }}</label>
                  <input
                    class="input input-sm"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    placeholder="Ingrese {{ element.label }}"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  />
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    {{ element.label }} es requerido
                  </div>
                </div>

                <mat-checkbox
                  *ngIf="element.element.name === 'CheckBox'"
                  [formControlName]="element.id.toString()"
                  [class.readonly]="isReadOnly">
                  {{ element.label }}
                </mat-checkbox>

                <div *ngIf="element.element.name === 'ComboBox'">
                  <label>{{ element.label }}</label>
                  <select class="select" [formControlName]="element.id.toString()" [class.readonly]="isReadOnly">
                    <option *ngFor="let option of element.options" [value]="option.value">
                      {{ option.value }}
                    </option>
                  </select>
                </div>

                <div *ngIf="element.element.name === 'Time'">
                  <label>{{ element.label }}</label>
                  <input
                    class="input input-sm"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    type="time"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  />
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    {{ element.label }} es requerido
                  </div>
                </div>

                <div *ngIf="element.element.name === 'Date'">
                  <label>{{ element.label }}</label>
                  <input
                    class="input input-sm"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    type="date"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  />
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    {{ element.label }} es requerido
                  </div>
                </div>

                <div *ngIf="element.element.name === 'TextArea'">
                  <label>{{ element.label }}</label>
                  <textarea
                    class="textarea"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    placeholder="Ingrese {{ element.label }}"
                    maxlength="200"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  ></textarea>
                  <div class="character-counter" [class.error]="isMaxLengthExceeded(element.id.toString())">
                    {{ getCharacterCount(element.id.toString()) }}/200 caracteres
                  </div>
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('maxlength') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    El texto no puede exceder los 200 caracteres
                  </div>
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    Este campo es requerido
                  </div>
                </div>

                <h3 class="mb-0" *ngIf="element.element.name === 'Label'">{{ element.label }}</h3>
              </div>
            </div>

            <!-- Elementos sin grupo dentro del step -->
            <div *ngIf="stepData.ungrouped.length" class="ungrouped-container mb-4">
              <div *ngFor="let element of stepData.ungrouped" class="field mb-3">
                <div *ngIf="element.element.name === 'TextBox'">
                  <label>{{ element.label }}</label>
                  <input
                    class="input"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    placeholder="Ingrese {{ element.label }}"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  />
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    {{ element.label }} es requerido
                  </div>
                </div>

                <mat-checkbox
                  *ngIf="element.element.name === 'CheckBox'"
                  [formControlName]="element.id.toString()"
                  [class.readonly]="isReadOnly">
                  {{ element.label }}
                </mat-checkbox>

                <div *ngIf="element.element.name === 'ComboBox'">
                  <label>{{ element.label }}</label>
                  <select class="select" [formControlName]="element.id.toString()" [class.readonly]="isReadOnly">
                    <option value="" selected>Selecciona</option>
                    <option *ngFor="let option of element.options" [value]="option.value">
                      {{ option.value }}
                    </option>
                  </select>
                </div>

                <div *ngIf="element.element.name === 'Time'">
                  <label>{{ element.label }}</label>
                  <input
                    class="input"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    type="time"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  />
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    {{ element.label }} es requerido
                  </div>
                </div>

                <div *ngIf="element.element.name === 'Date'">
                  <label>{{ element.label }}</label>
                  <input
                    class="input"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    type="date"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  />
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    {{ element.label }} es requerido
                  </div>
                </div>

                <div *ngIf="element.element.name === 'TextArea'">
                  <label>{{ element.label }}</label>
                  <textarea
                    class="textarea"
                    [formControlName]="element.id.toString()"
                    [readonly]="isReadOnly"
                    placeholder="Ingrese {{ element.label }}"
                    maxlength="200"
                    [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                  ></textarea>
                  <div class="character-counter" [class.error]="isMaxLengthExceeded(element.id.toString())">
                    {{ getCharacterCount(element.id.toString()) }}/200 caracteres
                  </div>
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('maxlength') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    El texto no puede exceder los 200 caracteres
                  </div>
                  <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                    Este campo es requerido
                  </div>
                </div>

                <h3 *ngIf="element.element.name === 'Label'">{{ element.label }}</h3>
              </div>
            </div>

            <!-- Botones de navegación del stepper -->
            <div class="stepper-buttons mt-4">
              
              <button mat-button matStepperPrevious [disabled]="isFirstStep()" (click)="goToPreviousStep()" class="mr-3">
                Anterior
              </button>
              <button mat-button matStepperNext (click)="goToNextStep()" class="mr-3">
                Siguiente
              </button>
              <button class="button button-outlined-danger ml-auto" (click)="close()">
                Cancelar
              </button>
            </div>
          </mat-step>

          <!-- Step final de confirmación -->
          <mat-step label="Finalización">
            <!-- Indicador de paso actual -->
            <!-- Debug info: isSaved={{isSaved}} | finalData={{finalData | json}} -->
            <ng-container *ngIf="isSaved && finalData; else confirmButtons">
              <div class="finalization-container">
                <h2>¡Turno cerrado correctamente!</h2>
                <p>
                  El turno se cerró de manera correcta, a continuación podrá revisar un resumen breve de la operación.
                </p>
                <ul>
                  <li><strong>Cierre turno:</strong> {{ finalData.id }}</li>
                  <li><strong>Jefe Turno:</strong> {{ finalData.chief }}</li>
                  <li><strong>Fecha Inicio:</strong> {{ finalData.startDate }}</li>
                  <li><strong>Fecha Fin:</strong> {{ finalData.endDate }}</li>
                </ul>
              </div>
              <div class="button-container">
                <button class="button button-outlined-danger button-sm mr-2" (click)="downloadPdf()">
                  Descargar PDF
                </button>
                <button class="button button-success button-sm" (click)="close()">
                  Finalizar
                </button>
              </div>
            </ng-container>

            <ng-template #confirmButtons>
              <div class="confirm-container">
                <h3>Confirmar cierre de turno</h3>
                <p>¿Está seguro de que desea proceder con el cierre del turno?</p>
              </div>
              <div class="stepper-buttons mt-4">
                @if(data.isBoss){
                <button mat-button matStepperPrevious (click)="goToPreviousStep()">
                  Anterior
                </button>}@else {
                  <button mat-button matStepperPrevious (click)="close()">
                  Cerrar
                </button>
                }
                <button mat-raised-button color="primary" (click)="confirm()">
                  Confirmar cierre de turno
                </button>
              </div>
            </ng-template>
          </mat-step>
        </mat-stepper>

     <!-- Si no hay steps o no es cierre de turno, mostrar formulario simple
       Nota: si es cierre de turno PERO no hay elementos, no mostramos formulario; mostramos confirmación directa abajo. -->
     <div *ngIf="(groupedData.steps.length === 0 || !isShiftClosure) && !noElements">
          <!-- Elementos agrupados -->
          <div *ngFor="let group of groupedData.noStep.grouped" class="grouped-container grid grid-cols-4 gap-4 mb-4">
            <div *ngFor="let element of group.elements" [ngClass]="element.element.name === 'Label' ? 'subtitle col-span-4' : 'field'">
              <!-- [Mismo contenido de elementos que arriba] -->
              <div *ngIf="element.element.name === 'TextBox'">
                <label>{{ element.label }}</label>
                <input
                  class="input input-sm"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  placeholder="Ingrese {{ element.label }}"
                />
              </div>

              <mat-checkbox
                *ngIf="element.element.name === 'CheckBox'"
                [formControlName]="element.id.toString()"
                [class.readonly]="isReadOnly">
                {{ element.label }}
              </mat-checkbox>

              <div *ngIf="element.element.name === 'ComboBox'">
                <label>{{ element.label }}</label>
                <select class="select" [formControlName]="element.id.toString()" [class.readonly]="isReadOnly">
                  <option *ngFor="let option of element.options" [value]="option.value">
                    {{ option.value }}
                  </option>
                </select>
              </div>

              <div *ngIf="element.element.name === 'Time'">
                <label>{{ element.label }}</label>
                <input
                  class="input input-sm"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  type="time"
                />
              </div>

              <div *ngIf="element.element.name === 'Date'">
                <label>{{ element.label }}</label>
                <input
                  class="input input-sm"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  type="date"
                />
              </div>

              <div *ngIf="element.element.name === 'TextArea'">
                <label>{{ element.label }}</label>
                <textarea
                  class="textarea"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  placeholder="Ingrese {{ element.label }}"
                  maxlength="200"
                  [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                ></textarea>
                <div class="character-counter" [class.error]="isMaxLengthExceeded(element.id.toString())">
                  {{ getCharacterCount(element.id.toString()) }}/200 caracteres
                </div>
                <div *ngIf="formGroup.get(element.id.toString())?.hasError('maxlength') && formGroup.get(element.id.toString())?.touched" class="error-message">
                  El texto no puede exceder los 200 caracteres
                </div>
                <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                  Este campo es requerido
                </div>
              </div>

              <h3 class="mb-0" *ngIf="element.element.name === 'Label'">{{ element.label }}</h3>
            </div>
          </div>

          <!-- Elementos sin grupo -->
          <div *ngIf="groupedData.noStep.ungrouped.length" class="ungrouped-container mb-4">
            <div *ngFor="let element of groupedData.noStep.ungrouped" class="field mb-3">
              <div *ngIf="element.element.name === 'TextBox'">
                <label>{{ element.label }}</label>
                <input
                  class="input"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  placeholder="Ingrese {{ element.label }}"
                />
              </div>

              <mat-checkbox
                *ngIf="element.element.name === 'CheckBox'"
                [formControlName]="element.id.toString()"
                [class.readonly]="isReadOnly">
                {{ element.label }}
              </mat-checkbox>

              <div *ngIf="element.element.name === 'ComboBox'">
                <label>{{ element.label }}</label>
                <select class="select" [formControlName]="element.id.toString()" [class.readonly]="isReadOnly">
                  <option value="" selected>Selecciona</option>
                  <option *ngFor="let option of element.options" [value]="option.value">
                    {{ option.value }}
                  </option>
                </select>
              </div>

              <div *ngIf="element.element.name === 'Time'">
                <label>{{ element.label }}</label>
                <input
                  class="input"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  type="time"
                />
              </div>

              <div *ngIf="element.element.name === 'Date'">
                <label>{{ element.label }}</label>
                <input
                  class="input"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  type="date"
                />
              </div>

              <div *ngIf="element.element.name === 'TextArea'">
                <label>{{ element.label }}</label>
                <textarea
                  class="textarea"
                  [formControlName]="element.id.toString()"
                  [readonly]="isReadOnly"
                  placeholder="Ingrese {{ element.label }}"
                  maxlength="200"
                  [class.error]="formGroup.get(element.id.toString())?.invalid && formGroup.get(element.id.toString())?.touched"
                ></textarea>
                <div class="character-counter" [class.error]="isMaxLengthExceeded(element.id.toString())">
                  {{ getCharacterCount(element.id.toString()) }}/200 caracteres
                </div>
                <div *ngIf="formGroup.get(element.id.toString())?.hasError('maxlength') && formGroup.get(element.id.toString())?.touched" class="error-message">
                  El texto no puede exceder los 200 caracteres
                </div>
                <div *ngIf="formGroup.get(element.id.toString())?.hasError('required') && formGroup.get(element.id.toString())?.touched" class="error-message">
                  Este campo es requerido
                </div>
              </div>

              <h3 *ngIf="element.element.name === 'Label'">{{ element.label }}</h3>
            </div>
          </div>
        </div>
      </mat-dialog-content>
      
      <div *ngIf="errorMessage" class="py-0 px-4">
        <div class="alert alert-danger">{{ errorMessage }}</div>
      </div>
    </div>

  <!-- Botones para formularios sin stepper (cuando no es cierre de turno y hay elementos) -->
  <mat-dialog-actions align="center" *ngIf="(groupedData.steps.length === 0 || !isShiftClosure) && !noElements">
      <!-- Mostrar botón "Cerrar" si es solo lectura -->
      <button class="button button-outlined-primary button-sm" *ngIf="isReadOnly" (click)="close()">Cerrar</button>

      <!-- Mostrar "Cancelar" y "Guardar" si no es solo lectura -->
      <ng-container *ngIf="!isReadOnly">
        <button class="button button-outlined-primary button-sm mr-2" (click)="close()">Cerrar</button>
        <button 
          *ngIf="!isSaved" 
          class="button button-success button-sm" 
          (click)="submit()">
          Guardar
        </button>
      </ng-container>
    </mat-dialog-actions>
  </form>
  </div>
</div>

<!-- Confirmación directa cuando es cierre de turno sin elementos -->
<div *ngIf="!isPreviewMode && isShiftClosure && noElements && !finalShiftReportData">
  <div class="confirm-container">
    <h3>Confirmar cierre de turno</h3>
    <p>Este formulario no requiere información adicional. ¿Desea confirmar el cierre de turno?</p>
  </div>
  <div class="confirm-actions mt-4">
    <button class="button button-outlined-primary button-sm" (click)="close()">Cerrar</button>
    <button class="button button-success button-sm" (click)="confirm()">Confirmar cierre de turno</button>
  </div>
</div>

<div *ngIf="shiftReportData">
  <h2 mat-dialog-title>{{ shiftReportData.title }}</h2>
  <div class="close-container">
    <button class="close" (click)="close()">
      <i class="fa-solid fa-xmark" alt=""></i>
    </button>
  </div>
  <mat-dialog-content>
    <p>{{ shiftReportData.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button class="button button-outlined-primary button-sm mr-2" (click)="close()">Cancelar</button>
    <button class="button button-success button-sm" (click)="confirmShiftReport()">Cerrar turno</button>
  </mat-dialog-actions>
</div>

<div *ngIf="finalShiftReportData">
  <div class="finalization-container">
    <h2>¡Turno cerrado correctamente!</h2>
    <p>
      El turno se cerró de manera correcta, a continuación podrá revisar un resumen breve de la operación.
    </p>
    <ul>
      <li><strong>Cierre turno:</strong> {{ finalShiftReportData.id }}</li>
      <li><strong>Jefe Turno:</strong> {{ finalShiftReportData.chief }}</li>
      <li><strong>Fecha Inicio:</strong> {{ finalShiftReportData.startDate }}</li>
      <li><strong>Fecha Fin:</strong> {{ finalShiftReportData.endDate }}</li>
    </ul>
  </div>
  <div class="button-container">
    <button class="button button-outlined-danger button-sm mr-2" (click)="downloadPdf()">
      Descargar PDF
    </button>
    <button class="button button-success button-sm" (click)="close()">
      Finalizar
    </button>
  </div>
</div>
